import { NextSeo } from 'next-seo';
import Head from 'next/head';
import React from 'react';
import { CONTACT } from '@common/constants';

import { Handyman } from '@modules/services/handyman/Handyman';

const TITLE = 'Expert Handyman Services in London | Qeeper';
const DESC = `Need handyman services that deal with more than just a hammer? Our multi-talented team  got solutions for all your home's needs! Call ${CONTACT.PHONE}`;
const URL = 'https://www.qeeper.co.uk/services/handyman';

const SEO_KEYWORDS =
  'handyman service, handymen, odd jobs, handy man service, hire a handyman';

const HandymanPage = () => {
  return (
    <>
      <Head>
        <meta name="keywords" content={SEO_KEYWORDS} />
        <link rel="canonical" key="canonical" href={URL} />
        <link rel="alternate" hrefLang="en" href={URL} />
      </Head>
      <NextSeo
        title={TITLE}
        description={DESC}
        canonical={URL}
        openGraph={{
          url: URL,
          title: TITLE,
          description: DESC,
        }}
      />
      <Handyman />
    </>
  );
};

export default HandymanPage;
